import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/_ui/_blocks/Wysiwyg/Wysiwyg.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Avatar/Avatar.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/_ui/Callouts/PromotionCallout/PromotionCallout.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(site)/regulation/Regulation.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Bookmark/BookmarkNavigation/BookmarkNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/CqcWidget/CqcWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/NextJs/ImageWithFallback/ImageWithFallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/NextJs/Link/Link.tsx");
